export const countries: string[] = [
    'fr-BE',
    'es-AR',
    'nl-BE',
    'pt-BR',
    'de-DE',
    'ca-ES',
    'es-ES',
    'fr-FR',
    'el-GR',
    'it-IT',
    'fr-LU',
    'es-MX',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sl-SI',
    'en-GB',
    'en-US',
    'de-AT'
];
